const common = {
    smtc: {
        // brand: 'Genomate®',
        copyright:
            '©2024 All Rights Reserved. Genomate® is a registered trademark. <1>Privacy Policy</1>, <3>Terms of Use</3> and <5>Disclaimer<5>.',
        footer: ' <0>User Manual</0> <1>Terms of Use</1> <2>Privacy Policy</2> <3>Disclaimer</3> '
    },
    header: {
        selectInstitute: 'Select institute',
        defaultInstitute: 'Working as private',
        account: 'Account',
        logout: 'Logout',
        profile: 'Manage profile'
    },
    labels: {
        genomateScore: 'Genomate Score',
        passwordStrength: 'Password strength',
        or: 'OR',
        andMore: 'and {{value}} more',
        noResultsFound: 'No results found.',
        na: 'N/A',
        unknown: 'Unknown',
        anonymous: 'Anonymous',
        reloadPage: 'Reload page',
        gender: {
            MALE: 'Male',
            FEMALE: 'Female',
            UNKNOWN: 'Unknown'
        },
        showMore: 'Show more',
        showLess: 'Show Less'
    },
    tableRowLabels: {
        DRIVER: 'Driver',
        BIOMARKER: 'Biomarker',
        NON_CONFIRMED_DRIVER: 'Conflicting driver',
        VUS: 'Variant of unknown significance',
        NON_DRIVER: 'Non-driver',
        VUS_IN_DRIVER: 'VUS in driver',
        GENOMIC_MARKER: 'Genomic marker'
    },
    testTypeAndTestResult: {
        NGS_NORMAL: 'wild type gene',
        NGS_MUTANT: 'mutant gene',
        NGS_UNKNOWN: 'unknown status gene',
        AMPLIFICATION_MUTANT: 'amplification presence',
        AMPLIFICATION_NORMAL: 'amplification absence',
        TRANSLOCATION_MUTANT: 'translocation presence',
        TRANSLOCATION_NORMAL: 'translocation absence',
        LOSS_MUTANT: 'loss presence',
        LOSS_NORMAL: 'loss absence',
        IHC_NORMAL: 'normal',
        IHC_OVER: 'protein overexpression',
        IHC_BELOW: 'protein lack of expression',
        MSI_HIGH: 'MSI-H',
        MSI_LOW: 'MSI-L',
        MSI_MSS: 'MSS',
        TMB_HIGH: 'TMB-H',
        TMB_LOW: 'TMB-L',
        HRD_POSITIVE: 'HRD-positive',
        HRD_NEGATIVE: 'HRD-negative',
        TIL_HIGH: 'TIL-H',
        TIL_LOW: 'TIL-L',
        IHC_LOW: 'low expression',
        UNKNOWN: ''
    },
    moduleLoadingError:
        'An error occured while trying to load module, please refresh.',
    sorting: {
        empty: 'Sort by',
        lastModifiedDate: 'Last modified date',
        name: 'Name',
        createdDate: 'Creation date'
    },
    buttons: {
        listView: 'See List View',
        goBackHome: 'Go Back Home',
        login: 'Log in',
        cancel: 'Cancel',
        submit: 'Submit',
        save: 'Save',
        close: 'Close'
    },
    errors: {
        unknown: {
            title: 'Something went wrong',
            description:
                'Druggable targets could not be loaded from the server.'
        },
        accessDenied: {
            title: 'Access Denied',
            description: 'You have no permission to view druggable targets.'
        },
        notFound: {
            description:
                'Your search has hit a DNA loop but our genetic engineers are hard at work untangling the strands.'
        },
        unknownError: 'Unknown error',
        400: '400 – Bad Request',
        401: '401 – Unauthorized',
        403: '403 – Forbidden',
        404: '404 – Not Found',
        422: '422 – Unprocessable Content',
        500: '500 – Internal Server Error',
        502: '502 – Bad Gateway',
        0: 'Unknown error',
        unexpected: 'Some unexpected error happened.',
        mtcHeaderLoadError: 'Header data could not be loaded: {{errorMessage}}',
        unauthorized:
            'You need to be logged in to perform the requested operation.',
        'Access Denied': 'Access Denied',
        validation: {
            user: {
                emailChange: {
                    keyExpired: 'Email confirmation key is expired',
                    'key.alreadyUsedOrMissing':
                        'Email change already confirmed',
                    'access.denied':
                        'Invalid Login for Email Confirmation - Please log in with the correct account to confirm the email change'
                }
            }
        }
    },
    a11y: {
        profile: {
            userProfile: 'User Profile',
            profilePopover: 'Profile Popover',
            avatar: 'Avatar',
            toggleIndicator: 'Toggle indicator'
        }
    },
    contact: {
        mailTo: '<1>support@genomate.health</1>',
        subject: 'Support request',
        ctaText: '<1>Contact</1>',
        body: 'User account / email address:\nDescription of the issue:\nWhen did the error occur:\nInternet browser:\nPlease attach screenshots if it is possible!',
        haveQuestions: 'If you have any questions',
        contactUsAnyTime: 'please feel free to contact us any time at'
    },
    fileUploader: {
        successMessage: 'Uploaded Successfully! Upload another?',
        disabledMessage: 'Upload disabled',
        fileTypeError: 'File type is not supported',
        fileSizeError: 'File size is too big',
        fileSizeTooSmallError: 'File size is too small',
        dropHereMessage: 'Drop Here',
        defaultDescription: 'Drop files or click to browse',
        fileTypeErrorMessage: 'File type is not supported',
        fileSizeErrorMessage: 'File size is too big',
        fileSizeTooSmallErrorMessage: 'File size is too small',
        size: 'size',
        types: 'types'
    },
    maintenance: {
        title: 'Maintenance',
        body: 'The Genomate Portal is currently under maintenance. Please try again later.'
    }
}

export default common
